var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfume1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5822 2.43809C18.9672 2.25062 19.1232 1.79469 18.9307 1.41975C18.7383 1.0448 18.2702 0.892827 17.8853 1.0803L15.8074 2.09234C15.4224 2.27981 15.2664 2.73574 15.4589 3.11068C15.6513 3.48563 16.1194 3.63761 16.5043 3.45013L18.5822 2.43809Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5822 6.1405C18.9672 6.32797 19.1232 6.7839 18.9307 7.15885C18.7383 7.53379 18.2702 7.68577 17.8853 7.49829L15.8074 6.48625C15.4224 6.29878 15.2664 5.84285 15.4589 5.46791C15.6513 5.09296 16.1194 4.94099 16.5043 5.12846L18.5822 6.1405Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4545 4.2893C17.4545 4.7085 17.8034 5.04833 18.2338 5.04833H20.3117C20.742 5.04833 21.0909 4.7085 21.0909 4.2893C21.0909 3.8701 20.742 3.53027 20.3117 3.53027H18.2338C17.8034 3.53027 17.4545 3.8701 17.4545 4.2893Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.7592C11.4262 1.7592 10.961 2.2123 10.961 2.77124V6.8194H10.7015C10.7015 6.9133 10.6836 7.00878 10.6456 7.10129L8.99512 11.1206H15.0049L13.3544 7.10129C13.3164 7.00878 13.2985 6.9133 13.2985 6.8194H13.039V4.79532C12.4652 4.79532 12 4.34221 12 3.78328C12 3.22434 12.4652 2.77124 13.039 2.77124C13.039 2.2123 12.5738 1.7592 12 1.7592Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1969 7.50066L16.6834 11.1206H21.1429L15.1969 7.50066Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3138 21.8511L15.2053 12.6386H8.79468L10.6862 21.8511C10.6964 21.9011 10.7014 21.9509 10.7014 22H13.2986C13.2986 21.9509 13.3036 21.9011 13.3138 21.8511Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7947 12.6386L14.8726 22H15.9106C16.6976 22 17.4171 21.5668 17.7691 20.8811L22 12.6386H16.7947Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85718 11.1206L8.80312 7.50066L7.31664 11.1206H2.85718Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20535 12.6386H2L6.23087 20.8811C6.58285 21.5668 7.30236 22 8.08942 22H9.12743L7.20535 12.6386Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfume1);
export default __webpack_public_path__ + "static/media/perfume-1.df33aba335df9f1b3541e5db18b2661b.svg";
export { ForwardRef as ReactComponent };